import { HStack, StackProps } from '@chakra-ui/react';
import * as React from 'react';

import { Image } from './components/Image';
import { ImagePlusMore } from './components/ImagePlusMore';

export const Images: React.FC<
  {
    urls: string[] | null;
    onClickImage: (index: number) => Promise<void>;
  } & StackProps
> = ({ urls, onClickImage, ...stackProps }) => {
  if (!urls || urls.length === 0) {
    return null;
  }
  if (urls.length === 1) {
    return (
      <HStack {...stackProps}>
        <Image src={urls[0]} onClick={() => onClickImage(0)} alt="" />
      </HStack>
    );
  } else {
    const remainingImages = urls.length - 2;
    return (
      <HStack {...stackProps}>
        <Image src={urls[0]} onClick={() => onClickImage(0)} alt="" />
        {remainingImages > 0 ? (
          <ImagePlusMore
            src={urls[1]}
            numOtherImages={remainingImages}
            onClick={() => onClickImage(1)}
          />
        ) : (
          <Image src={urls[1]} onClick={() => onClickImage(1)} alt="" />
        )}
      </HStack>
    );
  }
};
